import React, { useState } from 'react';
import { Box, Typography, Grid, Modal, TextField } from '@mui/material';
import RoundButton from '../components/roundButton';

export default function MoveModal(props) {
  const [value, setValue] = useState(1);
  const { open, handleClose, onValChange, max, lang } = props;
  const [errDisplay, setErrDisplay] = useState(false);
  const moveClick = () => {
    value > max || value < 0 ? setErrDisplay(true) : onValChange(value);
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common move-modal">
        <Grid container>
          <Grid item xs={12} md={12} lg={12} xl={12} className="align-center">
            <h5 className="m-1">Move Section</h5>
          </Grid>
          <Grid item xs={12} md={12} lg={12} xl={12} className="mb-1">
            <TextField
              type="number"
              sx={{
                fontSize: '17px',
                width: '100%',
                padding: '0 5px',
                '& input': {
                  padding: '7px'
                }
              }}
              placeholder={'Enter Section Number'}
              InputProps={{ inputProps: { min: 1, max: max } }}
              defaultValue={value}
              onChange={e => (setValue(e.target.value), setErrDisplay(false))}
              className="textbox w-100"
            />
          </Grid>
          {errDisplay && (
            <Grid item xs={12} md={12} lg={12} xl={12} className="mb-1">
              <Typography className="error align-center">
                Invalid move position. Please enter a value between 1 and {max}.
              </Typography>
            </Grid>
          )}
          <Grid xs={0} md={6} lg={6} xl={6}></Grid>
          <Grid item xs={6} md={3} lg={3} xl={3} className="pr-h-5">
            <RoundButton name={lang?.CANCEL} onClick={handleClose} />
          </Grid>
          <Grid item xs={6} md={3} lg={3} xl={3}>
            <RoundButton name={lang?.MOVE} onClick={() => moveClick()} />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
